import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  dateFrom: string;     // 請款日期 [從] (YYYY-MM-DD)
  dateTo: string;       // 請款日期 [至] (YYYY-MM-DD)
  invoiceFrom: string;  // 請款單號 [從] (6碼)
  invoiceTo: string;    // 請款單號 [至] (6碼)
  deptFrom: string;     // 部門代號 [從] (4碼)
  deptTo: string;       // 部門代號 [至] (4碼)
  vendorFrom: string;   // 廠商/員工代號 [從] (12碼)
  vendorTo: string;     // 廠商/員工代號 [至] (12碼)
  groupBy: string;      // 印表選擇: "vendor" / "dept" / "doc"
}

export interface ReportRow {
  fh110_01: string;         // 請款單號
  fh110_11: string | null;  // 請款日期
  fh110_16: string;         // 廠商/員工名稱
  fh110_37: string;         // 部門名稱
  fh110_22: string;         // 請款類別
  fh110_91: string;         // 請款人
  fh110_12: number;         // 未稅請款金額
  fh110_28: number;         // 稅額
  fh110_80: string;         // 核准狀態
  fh110_mk: string;         // 未核准標記
  fh113_01: string;         // 請款項目單號
  fh113_02: number;         // 請款項目序號
  fh113_11: string;         // 發票號碼
  fh113_12: string | null;  // 發票日期
  fh111_01: string;         // 費用明細單號
  fh111_02: number;         // 費用明細序號1
  fh111_03: number;         // 費用明細序號2
  fh111_11: string;         // 單據號碼/費用名稱
  fh111_111: string;        // 採購員名稱
  fh111_15: number;         // 未稅請款金額（明細）
  fh111_22: number;         // 稅額（明細）
  fh111_29: string;         // 部門代號（孫表）
}

export interface QueryResponse {
  data: ReportRow[];
  totalCount: number;
  message?: string;
}

export interface LookupResult {
  code: string;
  name: string;
}

// ============================================================
// API Client
// ============================================================

export const h312Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/h312/query', req);
    return res.data;
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/h312/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};
